<template>
    <nav class="panel">
        <p class="panel-heading">
            {{this.$store.state.siteName}}
        </p>
        <router-link class="panel-block" :to="{name: 'home'}">
            <span class="panel-icon">
                <i class="fas fa-home"></i>
            </span>
            Home
        </router-link>
         <router-link class="panel-block" :to="{name: 'list-files'}">
            <span class="panel-icon">
                <i class="fas fa-file"></i>
            </span>
            Files
         </router-link>
            <router-link class="panel-block" :to="{name: 'list-reports'}">
            <span class="panel-icon">
                <i class="fas fa-table"></i>
            </span>
            Data
        </router-link>
        <router-link class="panel-block" :to="{name: 'user-profile'}">
            <span class="panel-icon">
                <i class="fas fa-user"></i>
            </span>
            Profile
        </router-link>
    </nav>
</template>

<script>
    export default {
        name: "NavPanel"
    }
</script>

<style scoped>

</style>